"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.btoaCustom = exports.atobCustom = void 0;
const atobCustom = (str) => {
    if (typeof window !== 'undefined' && window.atob) {
        return window.atob(str);
    }
    else {
        return Buffer.from(str, 'base64').toString();
    }
};
exports.atobCustom = atobCustom;
const btoaCustom = (str) => {
    if (typeof window !== 'undefined' && window.btoa) {
        return window.btoa(str);
    }
    else {
        return Buffer.from(str).toString('base64');
    }
};
exports.btoaCustom = btoaCustom;
//# sourceMappingURL=base64.js.map